<template>
    <div class="form-horizontal">
        <div class="form-group">
            <label for="showcase_title" class="col-xs-12 col-md-4 control-label">{{$t('components.showcase.title')}}*</label>
            <div class="col-xs-12 col-md-8">
                <input type="text" id="showcase_title" name="showcase_title" placeholder="e.g., Hatha Yoga" class="form-control" v-model="showcase.title">
            </div>
        </div>
        <div class="form-group">
            <label for="showcase_desc" class="col-xs-12 col-md-4 control-label">{{$t('components.showcase.description')}}*</label>
            <div class="col-xs-12 col-md-8">
                <textarea type="textarea" id="showcase_desc" name="showcase_desc" placeholder="e.g., Your description here" class="form-control" v-model="showcase.description"></textarea>
            </div>
        </div>
        <div class="form-group">
            <label for="privacy-options" class="col-xs-12 col-md-4 control-label">Privacy</label>
            <div class="col-xs-12 col-md-8">
                <select id="privacy-options" class="form-control" v-model="showcase.privacy">
                    <option v-for="showcasePrivacy in privacyShowcaseOptions" :key="showcasePrivacy.value"
                            :value="showcasePrivacy.value">{{showcasePrivacy.name}}</option>
                </select>
            </div>
        </div>

        <div class="form-group" v-show="showcase.privacy===showcasePrivacyEnum.PASSWORD">
            <label for="showcase_password" class="col-xs-12 col-md-4 control-label">{{$t('components.showcase.password_showcase')}}*</label>
            <div class="col-xs-12 col-md-8">
                <input type="text" id="showcase_password" name="showcase_password" class="form-control" v-model="showcase.password">
            </div>
        </div>

        <div class="form-group" v-show="showcase.privacy===showcasePrivacyEnum.PURCHASED">
            <label for="showcase_price" class="col-xs-12 col-md-4 control-label">{{$t('common.price')}}*</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:200px;">
                    <input class="form-control" type="number" id="showcase_price" name="showcase_price" v-model="showcase.price" placeholder="0,00" step="0.01">
                    <div class="input-group-addon">{{default_currency}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {SHOWCASE_PRIVACY, SHOWCASE_PRIVACY_OPTIONS} from "../../common/constants";
    import {Utils} from "../../common/utils";
    export default {
        name: "ShowcaseForm",
        props: {
            showcaseProp: {
                type: Object,
                required: true
            }
        },
        methods: {
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        },
        data: () => {
            return {
                privacyShowcaseOptions: SHOWCASE_PRIVACY_OPTIONS(),
                showcasePrivacyEnum: SHOWCASE_PRIVACY,
                showcase: {
                    id: null,
                    state: null,
                    title: null,
                    description: null,
                    privacy: null,
                    password: null,
                    price: null
                },
                default_currency: ""
            }
        },
        mounted: function () {
            this.showcase = this.showcaseProp;
            this.default_currency = Utils.getCompanyCurrency();
        },
        watch: {
            showcaseProp: function(newVal) {
                this.showcase = newVal;
            },
            showcase: {
                handler(newVal) {
                    this.$emit('change', newVal)
                },
                deep: true,
            }
        }
    }
</script>
